
import cx from "classnames";
import CodeMirror from "@uiw/react-codemirror";

import Card from "../card";
import { useDraft } from "../useDraft";
import { canEdit } from "src/pages/experiences/storyboardSettings/utils/permissions";
import styles from "./customScriptCard.module.scss";
import {
  editorBasicSetup,
  editorExtensions,
  EDITOR_HEIGHT,
  EDITOR_PLACEHOLDER,
} from "./editorConfig";

const CustomScriptCard: React.FC = () => {
  const { draft, setField } = useDraft();
  const editable = canEdit(draft?.role);

  return (
    <Card
      title="Custom Script"
      description="Apply scripts at the storyboard level for site-wide custom abilities, comprehensive functionality and control"
    >
      <div className={cx(styles.editorWrapper, !editable && styles.disabled)}>
        <CodeMirror
          value={draft?.customScript ?? ""}
          height={EDITOR_HEIGHT}
          extensions={editorExtensions}
          editable={editable}
          readOnly={!editable}
          placeholder={EDITOR_PLACEHOLDER}
          basicSetup={editorBasicSetup}
          onChange={(value) => setField("customScript", value)}
        />
      </div>
    </Card>
  );
};

export default CustomScriptCard;
